import {
  ChangeDetectorRef,
  Component,
  NgModule,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, RouterModule, Routes } from '@angular/router';
import { GearsApiService } from 'src/app/services/gearsapi.service';
import { CommonModule, Location } from '@angular/common';
import { ModalService } from 'src/app/modules/modalservice.service';
import { SitesService } from 'src/app/services/sites.service';

import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { DetailsAlterComponent, DetailsAlterModule } from './detailsAlter/detailsAlter.component';
import { DetailsBaseComponent, DetailsBaseModule } from './detailsBase/detailsBase.component';

@Pipe({
  name: 'safe',
})
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(url: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
declare var Spin: any;
@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.less'],
})
export class DetailsComponent implements OnInit {
  @ViewChild('spin', { static: false }) spin: any;
  isAlternativeDetails : boolean = false;
  site: any;
  type: any;
  constructor(
    public modalService: ModalService,
    private siteService: SitesService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.siteService.get().then((site: any) => {
      this.isAlternativeDetails = site.layoutGlobal[0]?.PageLayoutType.find((x:any) => x.PageLayoutTypeName == 'AlternativeDetails') ? true : false;
      this.site = site;
      this.type = this.route.snapshot.paramMap.get('type')!
      this.isAlternativeDetails = (this.isAlternativeDetails && this.type) == 'new' ? true : false;
    });
    
  }
}
const routes: Routes = [
  {
    path: '',
    component: DetailsComponent,
    data: { Module: 'Buy', Title: 'Buy' },
  },
];

@NgModule({
    declarations: [
        DetailsComponent,
        SafePipe
    ],
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        DetailsBaseModule,
        DetailsAlterModule
    ]
})
export class DetailsModule {}
